



















import { Vue, Watch, Component } from 'vue-property-decorator';
import bread from '@/vuex/modules/bread';
import stores from '@/vuex/index';
@Component({})
export default class Breadcrumb extends Vue {
    public real: any = {};

    get getListData() {
        return this.$store.state.bread.listData;
    }

    created() {}
    public toHome() {
        this.$router.push('./dashboard');
    }

    public hasActive(item) {
        return item.name === this.$route.name;
    }
    // 自适应宽度
    public flxWidth(item){
      if(item.name.length==4){
        return 'span2'
      }
      else if(item.name.length < 4){
         return 'span2'
      }
      else {
        return 'span2'
      }
    }
    public closeSelectedTag(view: any) {
        stores.dispatch('bread/delVisitedViews', view).then((views) => {
            if (this.hasActive(view)) {
                let latestView = views.slice(-1)[0];
                if (latestView) {
                    this.$router.push(latestView.path);
                } else {
                    return;
                    this.$router.push('/dashboard');
                }
            }
        });
    }
}
